// extracted by css-extract-rspack-plugin
export default {"send-single":"send-single-c4yTkE","sendSingle":"send-single-c4yTkE","overflow":"overflow-YEAvKx"};